export const PRODUCT_PAGE_SIZES = [10, 20, 50, 100];

export const PRODUCT_SORT_OPTIONS = [
  { value: "newest", label: "Newest first" },
  { value: "oldest", label: "Oldest first" },
  { value: "name_asc", label: "Name: A–Z" },
  { value: "price_desc", label: "Price: high to low" },
  { value: "price_asc", label: "Price: low to high" },
  { value: "stock_desc", label: "Stock: high to low" },
  { value: "stock_asc", label: "Stock: low to high" },
];

function getCategoryLabel(product) {
  if (product.category?.name) return product.category.name;
  if (typeof product.category === "string") return product.category;
  return "";
}

function getSearchHaystack(product) {
  return [
    product.name,
    product.sku,
    product.slug,
    product.brand,
    product.manufacturer,
    getCategoryLabel(product),
    ...(product.tags || []),
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
}

function compareProducts(a, b, sortBy) {
  switch (sortBy) {
    case "oldest":
      return new Date(a.createdAt || 0) - new Date(b.createdAt || 0);
    case "name_asc":
      return String(a.name || "").localeCompare(String(b.name || ""), undefined, {
        sensitivity: "base",
      });
    case "price_desc":
      return Number(b.price || 0) - Number(a.price || 0);
    case "price_asc":
      return Number(a.price || 0) - Number(b.price || 0);
    case "stock_desc":
      return Number(b.stock || 0) - Number(a.stock || 0);
    case "stock_asc":
      return Number(a.stock || 0) - Number(b.stock || 0);
    case "newest":
    default:
      return new Date(b.createdAt || 0) - new Date(a.createdAt || 0);
  }
}

export function filterAndSortProducts(products, filters) {
  const {
    search = "",
    status = "all",
    featured = "all",
    sortBy = "newest",
  } = filters;

  const query = search.trim().toLowerCase();

  const filtered = (products || []).filter((product) => {
    if (status === "active" && !product.isActive) return false;
    if (status === "inactive" && product.isActive) return false;
    if (featured === "yes" && !product.isFeatured) return false;
    if (featured === "no" && product.isFeatured) return false;
    if (query && !getSearchHaystack(product).includes(query)) return false;
    return true;
  });

  return [...filtered].sort((a, b) => compareProducts(a, b, sortBy));
}
